import styled from '@emotion/styled';
import {
  UNASSIGNED_OVERLAY_COLOR_DARK_THEME,
  UNASSIGNED_OVERLAY_COLOR_LIGHT_THEME,
  UNASSIGNED_SEGMENT_BORDER_COLOR_DARK_THEME,
  UNASSIGNED_SEGMENT_BORDER_COLOR_LIGHT_THEME
} from '@/components/Packaging/constants';

const DurationWrapper = styled.div<{ color: string; hasAssignedInventory: boolean; isInvalid?: boolean }>`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(0.5)};

  overflow: hidden;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.25)};

  border: 1px solid
    ${({ theme, color, isInvalid, hasAssignedInventory }) => {
      const isDarkTheme = theme.palette.mode === 'dark';
      if (isInvalid) return theme.palette.error.main;
      if (isDarkTheme) {
        return hasAssignedInventory ? color : UNASSIGNED_SEGMENT_BORDER_COLOR_DARK_THEME;
      } else {
        return hasAssignedInventory ? '#13141B' : UNASSIGNED_SEGMENT_BORDER_COLOR_LIGHT_THEME;
      }
    }};
  border-radius: 4px;
  padding: ${({ theme }) => theme.spacing(0, 0.5)};
  font-size: 0.75rem;
  color: ${({ theme, color, hasAssignedInventory }) => {
    const isDarkTheme = theme.palette.mode === 'dark';
    if (isDarkTheme) {
      return hasAssignedInventory ? color : UNASSIGNED_OVERLAY_COLOR_DARK_THEME;
    } else {
      return hasAssignedInventory ? '#13141B' : UNASSIGNED_OVERLAY_COLOR_LIGHT_THEME;
    }
  }};
`;

export default DurationWrapper;
